import React, { useEffect } from "react";
import UploadFlowPanel from "../Components/UploadFlow/UploadFlowPanel";

/**
 * External AI Upload — full-viewport route. Uses the same upload surface as `/main`
 * via UploadFlowPanel so behavior stays aligned.
 */
const ExternalAIUpload = () => {
  useEffect(() => {
    document.body.classList.add("embed-mode");
    return () => document.body.classList.remove("embed-mode");
  }, []);

  return <UploadFlowPanel layoutMode="fullscreen" />;
};

export default ExternalAIUpload;
